import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { TemplateSubTab } from '@/types/admin.types';
import type { BuilderState } from '@/types/survey.types';
import { CatalogSubTab } from './CatalogSubTab';
import { TipsSubTab } from './TipsSubTab';
import { AccionesSubTab } from './AccionesSubTab';

interface TemplatesTabProps {
  onOpenBuilder: (state: BuilderState) => void;
}

// 2026-08-08: los catálogos maestros (Fundamentales y OUs) dejaron de ser subpestañas de Templates;
// ahora son secciones propias del grupo Admin General (ver `useAdminMenuSections`). Aquí quedan solo
// las subpestañas de Plantillas, visibles para cualquier admin que ve Templates.
const TEMPLATE_SUB_TABS: Array<{ id: TemplateSubTab; icon: string; labelKey: string }> = [
  { id: 'catalog',  icon: 'fa-layer-group', labelKey: 'admin.templates'  },
  { id: 'tips',     icon: 'fa-lightbulb',   labelKey: 'admin.tipsTab'    },
  { id: 'acciones', icon: 'fa-rocket',      labelKey: 'admin.actionsTab' },
];

export function TemplatesTab({ onOpenBuilder }: TemplatesTabProps) {
  const { t } = useTranslation();
  const [sub, setSub] = useState<TemplateSubTab>('catalog');

  // Si la subpestaña activa deja de existir, se cae a la primera (guarda defensiva).
  useEffect(() => {
    if (!TEMPLATE_SUB_TABS.some(subTab => subTab.id === sub)) {
      setSub(TEMPLATE_SUB_TABS[0].id);
    }
  }, [sub]);

  return (
    <div className="adm-tab-content">
      <div className="tpl-subnav">
        {TEMPLATE_SUB_TABS.map(subTab => (
          <button
            key={subTab.id}
            className={`tpl-subnav-btn${sub === subTab.id ? ' tpl-subnav-active' : ''}`}
            onClick={() => setSub(subTab.id)}
          >
            <i className={`fas ${subTab.icon}`} /> {t(subTab.labelKey)}
          </button>
        ))}
      </div>

      {sub === 'catalog'  && <CatalogSubTab onOpenBuilder={onOpenBuilder} />}
      {sub === 'tips'     && <TipsSubTab />}
      {sub === 'acciones' && <AccionesSubTab />}
    </div>
  );
}
